import { Route } from 'react-router-dom';
import type { ReactElement } from 'react';
import { BillingDashboardPage } from './dashboard/BillingPage';
import { BillingReportsPage } from './pages/Reports';
import { BillingSchedulesPage } from './pages/Schedules';
import { BillingRunsPage } from './pages/Runs';

/** Path → page. Billing picks the environment per report and schedule, so no environment shell. */
const PAGES: [string, () => ReactElement][] = [
  ['/billing/reports', () => <BillingReportsPage />],
  ['/billing/schedules', () => <BillingSchedulesPage />],
  ['/billing/runs', () => <BillingRunsPage />],
];

/** The Billing group's routes: the dashboard when the group may be opened, each page when its nav entry may be. */
export function billingRoutes(canOpenGroup: boolean, allowed: (path: string) => boolean) {
  return [
    canOpenGroup && <Route key="/billing" path="/billing" element={<BillingDashboardPage />} />,
    ...PAGES.filter(([path]) => allowed(path)).map(([path, page]) => (
      <Route key={path} path={path} element={page()} />
    )),
  ];
}
